import COLORS from './colors'

// CKO token semantics: colorPrimary = text/foreground, colorAction = brand accent.
// Do not set colorPrimary to brand blue — it tints inputs, labels, and field fills.
export const checkoutAppearance = {
  colorAction: COLORS.primary,
  colorBackground: COLORS.white,
  colorBorder: COLORS.ui.inputBorder,
  colorDisabled: COLORS.text.disabledInput,
  colorError: COLORS.error,
  colorFormBackground: COLORS.white,
  colorFormBorder: COLORS.ui.inputBorder,
  colorInverse: COLORS.white,
  colorOutline: COLORS.primary,
  colorPrimary: COLORS.text.header,
  colorSecondary: COLORS.text.label,
  colorSuccess: COLORS.success,
  button: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
  },
  footnote: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  input: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  label: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
  },
  subheading: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
  },
  borderRadius: ['8px', '8px'],
}

// CKO Flow scheme IDs — must match Checkout.com docs (e.g. american_express, not amex).
export const ACCEPTED_CARD_SCHEMES = ['visa', 'mastercard', 'american_express', 'discover']
